import { NgModule } from '@angular/core';
import { ToggleComponent } from './toggle.component';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [ToggleComponent],
  exports: [ToggleComponent],
  imports: [TooltipModule],
})
export class ToggleModule {}
